var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SlideSidebar'),_c('LoadingGlobal'),_c('CookieWarning'),_c('router-view'),_c('portal-target',{attrs:{"name":"body"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }